import { Routes } from '@angular/router';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { providerResolverFn } from './shared/_services/provider.resolver';
import { ExpiredPreviewComponent } from './pages/expired-preview/expired-preview.component';
import { notFoundResolverFn } from './shared/_services/not-found.resolver';
import { expiredResolverFn } from './shared/_services/expired.resolver';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: '404',
    component: NotFoundComponent,
    resolve: { provider: notFoundResolverFn },
  },
  {
    path: 'expired-preview',
    component: ExpiredPreviewComponent,
    resolve: { provider: expiredResolverFn },
  },
  {
    path: 'providers/:slug',
    loadComponent: () =>
      import('./pages/doctor-page/doctor-page.component').then(
        m => m.DoctorPageComponent
      ),
    resolve: { provider: providerResolverFn },
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/privacy-policy/privacy-policy.component').then(
        m => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./pages/terms-of-service/terms-of-service.component').then(
        m => m.TermsOfServiceComponent
      ),
  },
  {
    path: 'zoom-documentation',
    loadComponent: () =>
      import('./pages/zoom-documentation/zoom-documentation.component').then(
        m => m.ZoomDocumentationComponent
      ),
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./pages/support-page/support-page.component').then(
        m => m.SupportPageComponent
      ),
  },
  {
    path: 'unsubscribe',
    loadComponent: () =>
      import('./pages/unsubscribe/unsubscribe.component').then(
        m => m.UnsubscribeComponent
      ),
  },
  {
    path: '**',
    component: NotFoundComponent,
    resolve: { provider: notFoundResolverFn },
  },
];
